import { monthlyPlan, annualPlan, oneTimePlan, fullScholarshipPlan } from 'TuitionPlan';
import { scholarshipStubZenith150, scholarshipStubZenith200, cumulativeScholarshipStub400 } from 'Scholarship';

const { baseTuition } = monthlyPlan;

export const stubNoScholarshipQuanticPaymentSituations = [
    {
        tuitionPlan: oneTimePlan,
        cumulativeScholarshipAmount: 0,
        cumulativeScholarshipLevel: null,
        paymentInformation: {
            baseTuition,
            netScholarshipAmount: 0,
            netFeeAmount: 0,
            netDiscountAmount: 2000,
            netRequiredPayment: baseTuition - 2000,
            paymentAmountPerInterval: baseTuition - 2000,
            initialBalance: 0,
        },
        canReconcilePaymentsAutomatically: true,
    },
    {
        tuitionPlan: annualPlan,
        cumulativeScholarshipAmount: 0,
        cumulativeScholarshipLevel: null,
        paymentInformation: {
            baseTuition,
            netScholarshipAmount: 0,
            netFeeAmount: 0,
            netDiscountAmount: 0,
            netRequiredPayment: baseTuition,
            paymentAmountPerInterval: baseTuition / annualPlan.numIntervals!,
            initialBalance: 0,
        },
        canReconcilePaymentsAutomatically: true,
    },
    {
        tuitionPlan: monthlyPlan,
        cumulativeScholarshipAmount: 0,
        cumulativeScholarshipLevel: null,
        paymentInformation: {
            baseTuition,
            netScholarshipAmount: 0,
            netFeeAmount: 0,
            netDiscountAmount: 0,
            netRequiredPayment: baseTuition,
            paymentAmountPerInterval: baseTuition / monthlyPlan.numIntervals!,
            initialBalance: 0,
        },
        canReconcilePaymentsAutomatically: true,
    },
];

export const stubNoScholarshipQuanticBasePaymentSituation = {
    tuitionPlan: monthlyPlan,
    cumulativeScholarshipAmount: 0,
    cumulativeScholarshipLevel: null,
    paymentInformation: {
        baseTuition,
        netScholarshipAmount: 0,
        netFeeAmount: 0,
        netDiscountAmount: 0,
        netRequiredPayment: baseTuition,
        paymentAmountPerInterval: baseTuition / monthlyPlan.numIntervals!,
        initialBalance: 0,
    },
    canReconcilePaymentsAutomatically: true,
};

export const stubLevel150QuanticPaymentSituations = [
    {
        tuitionPlan: oneTimePlan,
        cumulativeScholarshipAmount: scholarshipStubZenith150.amount,
        cumulativeScholarshipLevel: scholarshipStubZenith150.level,
        paymentInformation: {
            baseTuition,
            netScholarshipAmount: scholarshipStubZenith150.amount,
            netFeeAmount: 0,
            netDiscountAmount: 1800,
            netRequiredPayment: baseTuition - scholarshipStubZenith150.amount! - 1800,
            paymentAmountPerInterval: baseTuition - scholarshipStubZenith150.amount! - 1800,
            initialBalance: 0,
        },
        canReconcilePaymentsAutomatically: true,
    },
    {
        tuitionPlan: annualPlan,
        cumulativeScholarshipAmount: scholarshipStubZenith150.amount,
        cumulativeScholarshipLevel: scholarshipStubZenith150.level,
        paymentInformation: {
            baseTuition,
            netScholarshipAmount: scholarshipStubZenith150.amount,
            netFeeAmount: 0,
            netDiscountAmount: 0,
            netRequiredPayment: baseTuition - scholarshipStubZenith150.amount!,
            paymentAmountPerInterval: (baseTuition - scholarshipStubZenith150.amount!) / annualPlan.numIntervals!,
            initialBalance: 0,
        },
        canReconcilePaymentsAutomatically: true,
    },
    {
        tuitionPlan: monthlyPlan,
        cumulativeScholarshipAmount: scholarshipStubZenith150.amount,
        cumulativeScholarshipLevel: scholarshipStubZenith150.level,
        paymentInformation: {
            baseTuition,
            netScholarshipAmount: scholarshipStubZenith150.amount,
            netFeeAmount: 0,
            netDiscountAmount: 0,
            netRequiredPayment: baseTuition - scholarshipStubZenith150.amount!,
            paymentAmountPerInterval: (baseTuition - scholarshipStubZenith150.amount!) / monthlyPlan.numIntervals!,
            initialBalance: 0,
        },
        canReconcilePaymentsAutomatically: true,
    },
];

export const stubLevel150QuanticBasePaymentSituation = {
    tuitionPlan: monthlyPlan,
    cumulativeScholarshipAmount: scholarshipStubZenith150.amount,
    cumulativeScholarshipLevel: scholarshipStubZenith150.level,
    paymentInformation: {
        baseTuition,
        netScholarshipAmount: scholarshipStubZenith150.amount,
        netFeeAmount: 0,
        netDiscountAmount: 0,
        netRequiredPayment: baseTuition - scholarshipStubZenith150.amount!,
        paymentAmountPerInterval: (baseTuition - scholarshipStubZenith150.amount!) / monthlyPlan.numIntervals!,
        initialBalance: 0,
    },
    canReconcilePaymentsAutomatically: true,
};

export const stubLevel200QuanticPaymentSituations = [
    {
        tuitionPlan: oneTimePlan,
        cumulativeScholarshipAmount: scholarshipStubZenith200.amount,
        cumulativeScholarshipLevel: scholarshipStubZenith200.level,
        paymentInformation: {
            baseTuition,
            netScholarshipAmount: scholarshipStubZenith200.amount,
            netFeeAmount: 0,
            netDiscountAmount: 1600,
            netRequiredPayment: baseTuition - scholarshipStubZenith200.amount! - 1600,
            paymentAmountPerInterval: baseTuition - scholarshipStubZenith200.amount! - 1600,
            initialBalance: 0,
        },
        canReconcilePaymentsAutomatically: true,
    },
    {
        tuitionPlan: annualPlan,
        cumulativeScholarshipAmount: scholarshipStubZenith200.amount,
        cumulativeScholarshipLevel: scholarshipStubZenith200.level,
        paymentInformation: {
            baseTuition,
            netScholarshipAmount: scholarshipStubZenith200.amount,
            netFeeAmount: 0,
            netDiscountAmount: 0,
            netRequiredPayment: baseTuition - scholarshipStubZenith200.amount!,
            paymentAmountPerInterval: (baseTuition - scholarshipStubZenith200.amount!) / annualPlan.numIntervals!,
            initialBalance: 0,
        },
        canReconcilePaymentsAutomatically: true,
    },
    {
        tuitionPlan: monthlyPlan,
        cumulativeScholarshipAmount: scholarshipStubZenith200.amount,
        cumulativeScholarshipLevel: scholarshipStubZenith200.level,
        paymentInformation: {
            baseTuition,
            netScholarshipAmount: scholarshipStubZenith200.amount,
            netFeeAmount: 0,
            netDiscountAmount: 0,
            netRequiredPayment: baseTuition - scholarshipStubZenith200.amount!,
            paymentAmountPerInterval: (baseTuition - scholarshipStubZenith200.amount!) / monthlyPlan.numIntervals!,
            initialBalance: 0,
        },
        canReconcilePaymentsAutomatically: true,
    },
];

export const stubLevel200QuanticBasePaymentSituation = {
    tuitionPlan: monthlyPlan,
    cumulativeScholarshipAmount: scholarshipStubZenith200.amount,
    cumulativeScholarshipLevel: scholarshipStubZenith200.level,
    paymentInformation: {
        baseTuition,
        netScholarshipAmount: scholarshipStubZenith200.amount,
        netFeeAmount: 0,
        netDiscountAmount: 0,
        netRequiredPayment: baseTuition - scholarshipStubZenith200.amount!,
        paymentAmountPerInterval: (baseTuition - scholarshipStubZenith200.amount!) / monthlyPlan.numIntervals!,
        initialBalance: 0,
    },
    canReconcilePaymentsAutomatically: true,
};

export const stubLevel400QuanticPaymentSituations = [
    {
        tuitionPlan: oneTimePlan,
        cumulativeScholarshipAmount: cumulativeScholarshipStub400.amount,
        cumulativeScholarshipLevel: cumulativeScholarshipStub400.level,
        paymentInformation: {
            baseTuition,
            netScholarshipAmount: cumulativeScholarshipStub400.amount,
            netFeeAmount: 0,
            netDiscountAmount: 1500,
            netRequiredPayment: baseTuition - cumulativeScholarshipStub400.amount! - 1500,
            paymentAmountPerInterval: baseTuition - cumulativeScholarshipStub400.amount! - 1500,
            initialBalance: 0,
        },
        canReconcilePaymentsAutomatically: true,
    },
    {
        tuitionPlan: annualPlan,
        cumulativeScholarshipAmount: cumulativeScholarshipStub400.amount,
        cumulativeScholarshipLevel: cumulativeScholarshipStub400.level,
        paymentInformation: {
            baseTuition,
            netScholarshipAmount: cumulativeScholarshipStub400.amount,
            netFeeAmount: 0,
            netDiscountAmount: 0,
            netRequiredPayment: baseTuition - cumulativeScholarshipStub400.amount!,
            paymentAmountPerInterval: (baseTuition - cumulativeScholarshipStub400.amount!) / annualPlan.numIntervals!,
            initialBalance: 0,
        },
        canReconcilePaymentsAutomatically: true,
    },
    {
        tuitionPlan: monthlyPlan,
        cumulativeScholarshipAmount: cumulativeScholarshipStub400.amount,
        cumulativeScholarshipLevel: cumulativeScholarshipStub400.level,
        paymentInformation: {
            baseTuition,
            netScholarshipAmount: cumulativeScholarshipStub400.amount,
            netFeeAmount: 0,
            netDiscountAmount: 0,
            netRequiredPayment: baseTuition - cumulativeScholarshipStub400.amount!,
            paymentAmountPerInterval: (baseTuition - cumulativeScholarshipStub400.amount!) / monthlyPlan.numIntervals!,
            initialBalance: 0,
        },
        canReconcilePaymentsAutomatically: true,
    },
];

export const stubLevel400QuanticBasePaymentSituation = {
    tuitionPlan: monthlyPlan,
    cumulativeScholarshipAmount: cumulativeScholarshipStub400.amount,
    cumulativeScholarshipLevel: cumulativeScholarshipStub400.level,
    paymentInformation: {
        baseTuition,
        netScholarshipAmount: cumulativeScholarshipStub400.amount,
        netFeeAmount: 0,
        netDiscountAmount: 0,
        netRequiredPayment: baseTuition - cumulativeScholarshipStub400.amount!,
        paymentAmountPerInterval: (baseTuition - cumulativeScholarshipStub400.amount!) / monthlyPlan.numIntervals!,
        initialBalance: 0,
    },
    canReconcilePaymentsAutomatically: true,
};

export const stubFullScholarshipQuanticPaymentSituations = [
    {
        tuitionPlan: fullScholarshipPlan,
        cumulativeScholarshipAmount: baseTuition,
        cumulativeScholarshipLevel: 99,
        paymentInformation: {
            baseTuition,
            netScholarshipAmount: baseTuition,
            netFeeAmount: 0,
            netDiscountAmount: 0,
            netRequiredPayment: 0,
            paymentAmountPerInterval: 0,
            initialBalance: 0,
        },
        canReconcilePaymentsAutomatically: true,
    },
];

export const stubFullScholarshipQuanticBasePaymentSituation = {
    tuitionPlan: monthlyPlan,
    cumulativeScholarshipAmount: 0,
    cumulativeScholarshipLevel: null,
    paymentInformation: {
        baseTuition,
        netScholarshipAmount: 0,
        netFeeAmount: 0,
        netDiscountAmount: 0,
        netRequiredPayment: baseTuition,
        paymentAmountPerInterval: baseTuition / monthlyPlan.numIntervals!,
        initialBalance: 0,
    },
    canReconcilePaymentsAutomatically: true,
};
